import React from 'react';
import { Carousel, Spin } from 'antd';
import { ImageLoadingObject } from '@common-types';
import { IChain, IImage } from '@share/common-types';
import './style.scss';
import { NOT_IMAGE_PROPERTY } from '@constants';
import { FormattedMessage } from 'react-intl';

interface IProps {
  images: IImage[];
  chain?: IChain | boolean;
}

interface IState {
  failedImages: string[];
  imagesMap: ImageLoadingObject;
}

const speed = 500;
const slidesToShow = 1;
const slidesToScroll = 1;

export class CondoCarouselHotelImages extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);

    this.state = {
      failedImages: [],
      imagesMap: this.generateImagesMap(),
    };
  }

  generateImagesMap = (): ImageLoadingObject => {
    return this.props.images.reduce((res: ImageLoadingObject, img: IImage, index: number) => {
      res[index] = {
        img,
        loading: true,
      };

      return res;
    }, {} as ImageLoadingObject);
  };

  componentDidUpdate(prevProps: Readonly<IProps>): void {
    if (prevProps.images !== this.props.images) {
      this.setState({ imagesMap: this.generateImagesMap() });
    }
  }

  addFailedImage = (src: string): void => {
    this.setState((prevState: IState) => {
      return {
        failedImages: [...prevState.failedImages, src],
      };
    });
  };

  onImageLoad = (index: number): void => {
    this.setState((prevState: IState) => {
      return {
        ...prevState,
        imagesMap: {
          ...prevState.imagesMap,
          [index]: {
            ...prevState.imagesMap[index],
            loading: false,
          },
        },
      };
    });
  };

  render(): React.ReactNode {
    const propsCarousel = {
      dots: false,
      infinite: true,
      arrows: true,
      speed,
      slidesToShow,
      slidesToScroll,
    };
    const { images, chain } = this.props;
    const { imagesMap, failedImages } = this.state;

    if (!images) {
      return null;
    }

    // Check if chain is an object with a thumb property
    const chainThumb = chain && typeof chain !== 'boolean' && chain.thumb ? chain.thumb : null;
    const chainName = chain && typeof chain !== 'boolean' && chain.name ? chain.name : '';

    return (
      <Carousel {...propsCarousel} lazyLoad="ondemand">
        {images.map((image: IImage, i: number) => {
          if (failedImages.includes(image.url)) {
            return null;
          }

          const notRealImageProperty = image.url?.toLowerCase().includes(NOT_IMAGE_PROPERTY);
          const styleImg: any = {};
          if (notRealImageProperty) {
            styleImg.filter = 'grayscale(100%)';
          }

          return (
            <div className="condo-custom-carousel-image" key={i}>
              <div
                className="condo-custom-carousel-image__spinner"
                style={{ display: imagesMap[i]?.loading ? 'flex' : 'none' }}
              >
                <Spin />
              </div>

              {notRealImageProperty && (
                <div style={{ position: 'absolute', top: '0', right: '0', bottom: '0', left: '0', background: 'rgba(0, 0, 0, 0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 200 }}>
                  <p className="condo-hotel-card__label-title" style={{ color: 'white', fontSize: '12px' }}>
                    <FormattedMessage
                      id="not.real.image.property"
                      defaultMessage="Not actual photo of the property"
                    />
                  </p>
                </div>)}

              <img
                style={{ display: imagesMap[i]?.loading ? 'none' : 'block', ...styleImg }}
                className="condo-custom-carousel-image__item"
                src={image.url}
                alt={image.description}
                onLoad={() => this.onImageLoad(i)}
                onError={() => this.addFailedImage(image.url)}
              />

              {chainThumb && !imagesMap[i]?.loading && (
                <img
                  src={chainThumb}
                  alt={"Chain " + chainName}
                  className="condo-custom-carousel-image__chain-logo"
                />)}
            </div>
          );
        })}
      </Carousel>
    );
  }
}
